import PropTypes from 'prop-types';

import { Doughnut } from 'react-chartjs-2';
import { useRef } from 'react';
import { numberFormat } from '@/utils/unitUtils';
import { createDoughnutCenterLabelPlugin } from './plugins';

const defaultColors = ['#4977CE', '#ABC4FB', '#D4E1FD'];

const buildOptions = (yAxisLabel, options = {}) => ({
  cutout: '80%',
  radius: '90%',
  responsive: true,
  elements: {
    arc: {
      spacing: 4,
    },
  },
  layout: {
    padding: 10,
  },
  plugins: {
    ...(yAxisLabel && {
      yAxisLabel: {
        enabled: true,
        text: yAxisLabel,
      },
    }),
    legend: {
      display: false,
    },
    tooltip: {
      position: 'nearest',
      callbacks: {
        label: context => {
          return numberFormat(context.raw);
        },
      },
    },
  },
  ...options,
});

const DoughnutChart = ({ data, showCenterLabel = false, variant = 'default' }) => {
  const { yAxisLabel, maxScope, labels, colors: backgroundColor = defaultColors } = data;
  const ref = useRef();

  const breakDownOptions =
    variant === 'breakdown'
      ? {
          radius: '100%',
          cutout: '60%',
          aspectRatio: 2,
          layout: {
            padding: {
              top: 30,
              left: 20,
            },
          },
        }
      : {};

  const options = buildOptions(yAxisLabel, breakDownOptions);

  const enableCenter =
    showCenterLabel && maxScope && typeof maxScope.label === 'string' && typeof maxScope.proportion === 'number';

  const plugins = enableCenter ? [createDoughnutCenterLabelPlugin({ maxScope })] : [];

  return (
    <Doughnut
      ref={ref}
      options={options}
      plugins={plugins}
      data={{ labels: labels, datasets: [{ data: data.data, backgroundColor }] }}
    />
  );
};

DoughnutChart.propTypes = {
  data: PropTypes.object,
  showCenterLabel: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'breakdown']),
};

export default DoughnutChart;
